import {
  request2
} from './request.js'
//获取老师微信号列表
export function GetPageList(obj) {
  return request2({
      url: '/api2/TZsbAdminApi/AdminWeiXin/GetPageList',
      method: 'get',
      params: {
        Number:obj.Number,
        WeiXinId: obj.WeiXinId,
        IsEnterprise: obj.IsEnterprise,
        IsOpen: obj.IsOpen,
        AdminName: obj.AdminName,
        RoleName: obj.RoleName,
        pageIndex: obj.pageIndex,
        pageSize: obj.pageSize,
        IsQueryRepeat:obj.IsQueryRepeat,
    }
  })
} 

//   单个删除老师微信号
export function DelAdminWXById(id) {
  return request2({
      url: '/api2/TZsbAdminApi/AdminWeiXin/DelAdminWXById?id=' + id,
      method: 'post',
  })
}
//   编辑指定老师微信
export function EditAdminWeixin(obj) {
  return request2({
      url: '/api2/TZsbAdminApi/Admin/EditAdminWeixin',
      method: 'post',
      data: {
        id:obj.id,
        adminId: obj.adminId,
        number: obj.number,
        isOpen: obj.isOpen,
        isEnterprise: obj.isEnterprise,
    }
  })
}
//   获取老师微信—编辑时使用
export function GetAdminWeiXin(id) {
  return request2({
      url: '/api2/TZsbAdminApi/Admin/GetAdminWeiXin?id=' + id,
      method: 'get',
  })
}